/**
 * @file Route: newcollections
 *
 * This file is compiled as a standalone entrypoint and it is included by
 * default in its blade template.
 * This is a "standard" route, it does not have a structure to follow, you are
 * sure the DOM is always ready and the JS will only be executed in this route.
 */

import "layouts/main";
import { Header } from "components/Header/Info";
import gallery from "components/Gallery";
// import { clickCta } from "components/Dl";
import { $, $all, forEach, on } from "@olmokit/dom";
import "components/Cover";
import "./index.scss";

console.log("Route newcollections/index.js mounted.");

Header();

gallery('.first:')
gallery('.second:')
gallery('.third:')

const ctas = $all(".dlClickCta");
if (ctas) {
  forEach(ctas, c => {
    on(c, "click", () => {
    //   clickCta(c.getAttribute("data-link"), c.getAttribute("data-label"));
    });
  });
}

